module.exports = __webpack_public_path__ + "img/bcl.fa7ddb47.svg";